/** @format */

import { Card } from "react-bootstrap";

const table1 = [
  {
    row: "1",
    firstname: "Mark",
    lastname: "Otto",
    handle: "@mdo",
  },
  {
    row: "2",
    firstname: "Jacob",
    lastname: "Thornton",
    handle: "@fat",
  },
  {
    row: "3",
    firstname: "Larry",
    lastname: "the Bird",
    handle: "@twitter",
  },
];

const Bookmark = () => {
  return (
    <Card>
      <Card.Header className="d-flex justify-content-between">
        <div className="header-title">
          <h4 className="card-title">Bookmarks</h4>
        </div>
      </Card.Header>
      <Card.Body className="pt-0">
        <table className="table table-striped ">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Company</th>
              <th scope="col">Applied Date</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {table1.map((item, idx) => (
              <tr key={idx}>
                <th scope="row">{item.row}</th>
                <td>{item.firstname}</td>
                <td>{item.lastname}</td>
                <td>{item.handle}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card.Body>
    </Card>
  );
};

export default Bookmark;
